import { ReactNode } from "react";

interface PageLayoutProps {
  children: ReactNode;
}

// Soft brand-tinted backdrop. Colours come from the whitelabel CSS vars, so it follows each merchant's palette.
const backdropStyle = {
  backgroundColor: "#F5F3FA",
  backgroundImage: [
    "radial-gradient(60rem 40rem at 0% 0%, rgb(var(--brand-rgb) / 0.16), transparent 60%)",
    "radial-gradient(50rem 36rem at 100% 100%, rgb(var(--brand-end-rgb) / 0.14), transparent 60%)",
    "radial-gradient(30rem 24rem at 85% 10%, rgb(var(--brand-soft-rgb) / 0.12), transparent 70%)",
  ].join(", "),
};

const gridStyle = {
  backgroundImage:
    "linear-gradient(rgb(var(--brand-dark-rgb) / 0.05) 1px, transparent 1px), linear-gradient(90deg, rgb(var(--brand-dark-rgb) / 0.05) 1px, transparent 1px)",
  backgroundSize: "32px 32px",
  maskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
  WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 75%)",
};

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <div
      className="relative min-h-screen w-full overflow-hidden md:flex items-center justify-center px-3 py-8 md:px-6 lg:px-8"
      style={backdropStyle}
    >
      <div aria-hidden className="pointer-events-none absolute inset-0" style={gridStyle} />
      <main className="relative w-full md:max-w-3xl md:justify-center">{children}</main>
    </div>
  );
}
